import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Teach tailwind-merge about our custom `--shadow-stroked` theme shadow so it
// conflicts with `shadow-none`/`shadow-*` (e.g. InputGroupInput cancelling the
// base Input's `shadow-stroked`). Without this both classes survive the merge.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ['stroked'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
